import { useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import type { Check } from "./preparation-types";
export function usePreparationMessageWorkspace({ check, notify, onSaved, }: {
    check: Check;
    notify: (message: string) => void;
    onSaved: (check: Check) => void;
}) {
    const [type, setType] = useState("TRANSFER_REQUEST");
    const [materialCode, setMaterialCode] = useState(check.items[0]?.materialCode ?? "");
    const [requestedQuantity, setRequestedQuantity] = useState("");
    const [message, setMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const isQuantityRequest = type === "MATERIAL_REQUEST" || type === "TRANSFER_REQUEST";
    const selectedItem = check.items.find((item) => item.materialCode === materialCode);
    const submit = async () => {
        if (message.trim().length < 3) {
            notify("Açıklamayı en az 3 karakter girin.");
            return;
        }
        const numericQuantity = Number(requestedQuantity);
        if (isQuantityRequest &&
            (!selectedItem ||
                requestedQuantity === "" ||
                !Number.isFinite(numericQuantity) ||
                numericQuantity <= 0)) {
            notify("Talep için malzeme ve sıfırdan büyük miktar seçin.");
            return;
        }
        setSaving(true);
        try {
            onSaved(await apiRequest<Check>(`/api/material-preparation/checks/${check.id}/messages`, {
                method: "POST",
                body: JSON.stringify({
                    type,
                    message: message.trim(),
                    ...(isQuantityRequest && selectedItem
                        ? {
                            materialCode: selectedItem.materialCode,
                            requestedQuantity: numericQuantity,
                            unit: selectedItem.unit,
                        }
                        : {}),
                    idempotencyKey: crypto.randomUUID(),
                    expectedVersion: check.version,
                }),
            }));
            setMessage("");
            setRequestedQuantity("");
        }
        catch (error) {
            notify(error instanceof Error ? error.message : "İş akışı kaydedilemedi.");
        }
        finally {
            setSaving(false);
        }
    };
    return { type, setType, materialCode, setMaterialCode, requestedQuantity, setRequestedQuantity, message, setMessage, saving, isQuantityRequest, selectedItem, submit };
}
